import ACTIONS from '../actions';
import * as AppState from '../app/appState';
import { getStore, getState } from '../../store';
import * as Cookie from '../../../lib/cookie';
import CONF from '../../../api/config';

export const authWithCookie = async sessionToken => {
    const hasLegacySession = sessionToken && sessionToken !== 'null';
    if (hasLegacySession) {
        setSessionToken({ session_id: sessionToken });
    }

    await AppState.getCurrentLoggedInUser();
    if (getState().app.loggedInUser && getState().app.loggedInUser.id) {
        getStore().dispatch({
            type: ACTIONS.AUTH_SUCCESS
        });
    }
};

export const checkToken = () => {
    const cookieToken = Cookie.getCookie(CONF.SESSION_NAME);
    const stateToken = getState().auth.token;
    const hasLegacySession = cookieToken && cookieToken !== 'null';

    if (!hasLegacySession) {
        return AppState.getCurrentLoggedInUser();
    }

    if (cookieToken === stateToken) {
        return AppState.getCurrentLoggedInUser();
    }

    return authWithCookie(cookieToken);
};

export const setSessionToken = token => {
    getStore().dispatch({
        type: ACTIONS.AUTH_SET_SESSION_TOKEN,
        token
    });
};
